import { restClient } from '@/Core'

import { toCollection, toNode } from '../Helpers/diskResponse'

import type { DiskCollection, DiskNode, DiskSort } from '../Contracts/DiskNode'

/** Стеля `limit` колекції вузлів на беку. */
const FOLDER_PAGE_LIMIT = 300

export interface LoadDiskFolderItemsParams {
    parent: string
    sort?: DiskSort
    /** Лише папки — для дерева й модалки переміщення. */
    foldersOnly?: boolean
}

/**
 * Вміст папки: `GET /services/disk/nodes?parent=`. Папки бек ставить зверху
 * за будь-якого сортування; сортування й фільтр — за його білим списком.
 */
export const LoadDiskFolderItemsTask = async ({
    parent,
    sort,
    foldersOnly = false,
}: LoadDiskFolderItemsParams): Promise<DiskCollection<DiskNode>> => {
    const searchParams: Record<string, string> = { parent, limit: String(FOLDER_PAGE_LIMIT) }

    if (sort) {
        searchParams['sort'] = sort.field
        searchParams['order'] = sort.order
    }

    if (foldersOnly) {
        searchParams['filters'] = JSON.stringify({ and: [{ field: 'type', op: '=', value: 'folder' }] })
    }

    const response = (await restClient.get('/services/disk/nodes', { searchParams }, { forceRefresh: true })) as unknown

    return toCollection(response, toNode)
}
